(function(window, undefined) {

    'use strict';



    /*jshint boss:true */


    /**
     * misc utilities for the project
     */



    /**
     * @module Messages
     *
     * Generated by JSONP whenever either new JSONP requests have fired or all have been fulfilled
     *
     * @function loading_data_changed
     * @param {String}  messageKind='loading_data_changed'
     * @param {Boolean} isLoading
     */


    SAPO.namespace('Utility');



    // SOME DOM USEFUL STUFF
    var Ajax  = SAPO.Communication.Ajax,
        JsonP = SAPO.Communication.JsonP,
        Css   = SAPO.Dom.Css,
        Ut    = SAPO.Utility;



    // for old IEs to play...
    if (Array.prototype.indexOf) {
        Ut.arrIndexOf = function(arr, str) {
            return arr.indexOf(str);
        };
    }
    else {
        Ut.arrIndexOf = function(arr, str) {
            for (var i = 0, f = arr.length; i < f; ++i) {
                if (arr[i] === str) {
                    return i;
                }
            }
            return -1;
        };
    }



    Ut.hasAncestor = function hasAncestor(el, ancestorEl) {
        if (!el) { return false; }
        if (el === ancestorEl) { return true; }
        return hasAncestor(el.parentNode, ancestorEl);
    };

    Ut.hasAncestorClass = function hasAncestorClass(el, ancestorClass) {
        if (!el) { return false; }
        if (Css.hasClassName(el, ancestorClass)) { return el; }
        return hasAncestorClass(el.parentNode, ancestorClass);
    };

    // NOTE: keep in mind that if using the native function, you WILL NOT get an array
    Ut.getElementsByClassName = function(className, startingEl) {
        if (document.getElementsByClassName) {
            if (!startingEl) { startingEl = document; }
            return startingEl.getElementsByClassName(className);
        }

        if (!startingEl) { startingEl = document.body; }
        var els = document.getElementsByTagName('*');
        var els2 = [];
        for (var i = 0, f = els.length, el; i < f; ++i) {
            el = els[i];
            if (Css.hasClassName(el, className)) {
                els2.push(el);
            }
        }
        return els2;
    };

    var pad00 = function pad_00(n) {
        return (n < 10) ? '0' + n : n;
    };

    var formatTime  = function format_time(t0) {
        var secs = Math.floor(t0 % 60);
        var mins = Math.floor(t0 / 60);
        var h = Math.floor(mins / 60);
        var arr;
        if (h > 0) {
            mins -= h * 60;
            arr = [h, pad00(mins), pad00(secs)];
        }
        else {
            arr = [mins, pad00(secs)];
        }
        return arr.join(':');
    };

    SAPO.Utility.formatTime = formatTime;

    var Node = window.Node || {
        ELEMENT_NODE:                 1,
        ATTRIBUTE_NODE:               2,
        TEXT_NODE:                    3,
        CDATA_SECTION_NODE:           4,
        ENTITY_REFERENCE_NODE:        5,
        ENTITY_NODE:                  6,
        PROCESSING_INSTRUCTION_NODE:  7,
        COMMENT_NODE:                 8,
        DOCUMENT_NODE:                9,
        DOCUMENT_TYPE_NODE:          10,
        DOCUMENT_FRAGMENT_NODE:      11,
        NOTATION_NODE:               12
    };

    // Set of utilities to help traverse an xml file
    var xml = {

        trim: (''.trim || String.prototype.trim) ?
            function(str) { return (''.trim || String.prototype.trim).apply(str);  } :
            function(str) { return str.replace(/^\s+|\s+$|\n+$/g, '');  },

        text: function(node) {
            if (!node) {                 return '';               }
            if ('textContent' in node) { return node.textContent; }
            if ('innerText' in node) {   return node.innerText;   }

            var t = [];
            if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.CDATA_SECTION_NODE) {
                t.push(node.nodeValue);
            }
            else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                for(var k = 0, cs = node.childNodes, c, lim = cs.length; k < lim && (c = cs[k]); k++) {
                    t.push(this.text(c));
                }
            }
            return t.join('');
        },

        trimmedText: function(node) {
            return this.trim( this.text(node) );
        },

        getNode: function(item, tagName) {
            //console.log('GET NODE');
            if (tagName.indexOf(':') < 0) { return item.getElementsByTagName(tagName)[0]; }
            var tokens = tagName.split(':');
            var n, ns = item.getElementsByTagName(tagName);
            for (var k = 0, kf = ns.length; k < kf; k++) {
                n = ns[k];
                if (n.prefix === tokens[0]) { return n; }
            }
            return null;
        },

        getNodeNS: function(item, ns, tagName) {
            //console.log('GET NODE NS');
            if (tagName && 0 <= tagName.indexOf(':')) { tagName = tagName.split(':')[0]; }
            if (item.getElementsByTagNameNS){ return item.getElementsByTagNameNS(ns, tagName)[0]; }

            // IE path
            for (var cur = item; cur; cur = cur.parentNode) {
                if (cur.nodeType === 1){
                    for (var k = 0, as = cur.attributes, a; a = as[k]; k++){
                        if (a.value === ns) {
                            if (a.name === 'xmlns') {                  return xml.getNode(item, tagName);                             }
                            if (a.name.substring(0, 6) === 'xmlns:') { return xml.getNode(item, a.name.substring(6) + ':' + tagName); }
                        }
                    }
                }
            }
            return null;
        },

        getChildren: function(item, tagName) {
            var r1 = item.getElementsByTagName(tagName);
            if (r1.length === 0 && item.tagName === tagName) {
                return [item];
            }
            return r1;
        },

        getText: function(item, tagName, ns){
            var n = (ns !== undefined) ? xml.getNodeNS(item, ns, tagName) : xml.getNode(item, tagName);
            n = n && xml.trim(xml.text(n));
            return n || '';
        },

        getTrimmedText: function(item, tagName, ns) {
            return this.trim( this.getText(item, tagName, ns) );
        },

        /*getNumber: function(item, tagName, ns){
            var n = (ns !== undefined) ? xml.getNodeNS(item, ns, tagName) : xml.getNode(item, tagName);
            n = n && xml.trim(xml.text(n));
            return Number(n);
        },*/

        getBoolean: function(item, tagName, ns){
            var n = (ns !== undefined) ? xml.getNodeNS(item, ns, tagName) : xml.getNode(item, tagName);
            if (!n) { return false; }
            n = n && xml.trim(xml.text(n));
            if (n && n.toLowerCase() === 'false') { return false;   }
            return Boolean(n);
        },

        getNumber: function(item, tagName, ns){
            var n = (ns !== undefined) ? xml.getNodeNS(item, ns, tagName) : xml.getNode(item, tagName);
            n = n && xml.trim(xml.text(n));
            return parseFloat(n);
        },

        getAttr: function(item, tagName, attr, ns){
            var n = (ns !== undefined) ? xml.getNodeNS(item, ns, tagName) : xml.getNode(item, tagName);
            return n && xml.trim(n.getAttribute(attr) || '');
        },

        parseDOM: function(str, returnDocument) {
            var parser, node;

            if (window.DOMParser) { // chrome, ff, IE >= 9
                parser = new DOMParser();
                node = parser.parseFromString(str, 'text/xml');
            }
            else { // IE8
                parser = new window.ActiveXObject('Microsoft.XMLDOM');
                parser.async = false;
                parser.loadXML(str);

                if (parser.parseError.errorCode !== 0) {
                    var err = parser.parseError;
                    throw err;
                }

                node = parser;
            }

            if (returnDocument) {
                return node;
            }


            if (node.nodeType === Node.DOCUMENT_NODE) { node = node.firstChild; }

            while (node && node.nodeType !== Node.ELEMENT_NODE) {
                node = node.nextSibling;
            }

            return node;
        },

        parseTime: function(str) {
            if (str.match(/(\d+):(\d+):(\d+)/) || str.match(/()(\d+):(\d+)/)) {
                return parseInt(RegExp.$1, 10) * 3600 +
                       parseInt(RegExp.$2, 10) * 60 +
                       parseInt(RegExp.$3, 10);
                }
                return undefined;
        }
    };

    SAPO.Utility.XML2 = xml;



    /* from /SAPO/Utility/String/0.1/ */
    /*var utf8Decode = function(u) {
        var s = [];
        var i = 0, c = 0, d = 0, e = 0;
        while (i < u.length) {
            c = u.charCodeAt(i);
            if (c < 128) {
                s.push( String.fromCharCode(c) );
                ++i;
            }
            else if (c > 191 && c < 224) {
                d = u.charCodeAt(i+1);
                s.push( String.fromCharCode(((c & 31) << 6) | (d & 63)) );
                i += 2;
            }
            else {
                d = u.charCodeAt(i+1);
                e = u.charCodeAt(i+2);
                s.push( String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)) );
                i += 3;
            }
        }
        return s.join('');
    };*/



    // via regular AJAX call with CORS
    var ajaxCORS = function(uri, onOk, onErr, timeout, tryToSendCookies, isSynchronous) {
        var genOptions = function(withCredentials, onOk, onErr) {
            return {
                method:         'GET',
                cors:           true,
                asynchronous:   !isSynchronous,
                timeout:        timeout || 10,
                useCredentials: withCredentials,
                onSuccess:      onOk,
                onException:    onErr,
                onTimeout:      onErr,
                onFailure:      onErr
            };
        };

        var onOk0 = function() {
            var args = Array.prototype.slice.call(arguments);
            onOk.apply(null, args);
        };

        var onErr1 = function() {
            var args = Array.prototype.slice.call(arguments);
            onErr.apply(null, args);
        };

        if (tryToSendCookies) {
            var onErr0 = function() {
                new Ajax(uri, genOptions(false, onOk0, onErr1));
            };

            new Ajax(uri, genOptions(true, onOk0, onErr0));
        }
        else {
            new Ajax(uri, genOptions(false, onOk0, onErr1));
        }
    };



    /*var cloneXML = function(doc) {
        try {
            var str = (new XMLSerializer()).serializeToString(doc);
            return xml.parseDOM(str, true);
        } catch (ex) {
            return;
        }
    };*/



    // using flash to overcome browser limitations
    var flashCORS = function(uri, onOk, onErr, timeout/*, tryToSendCookies, isSynchronous*/) {
        SAPO.Communication.CorsInFlash(
            uri,
            {
                //format: 'xml', // does not work?!
                method: 'GET',
                timeout: timeout || 10
            },
            function(err, resp, status/*, statusText*/) { // CALLBACK: receives error, response, status and statusText
                if (err) {
                    return onErr(err);
                }

                //resp = cloneXML(resp);

                if (typeof resp === 'string') {
                    if (resp.substring(0, 5).toLowerCase() === '<?xml') {
                        // removes doctype header. apparently not necessary
                        //var cutAt = resp.indexOf('>');
                        //resp = resp.substring(cutAt + ((resp.charAt(cutAt+1) === '\n') ? 2 : 1));

                        //console.log('xml string\n', resp);
                        try {
                            resp = xml.parseDOM(resp);
                        } catch (ex) {
                            return onErr(ex, {});
                        }
                        //console.log('xml\n', resp);
                    }
                    else {
                        resp = JSON.parse(resp);
                        //console.log('JSON ', uri);
                    }
                }

                //onOk(status, resp);
                setTimeout(function() {
                    onOk(status, resp);
                }, 0);
            }
        );
    };

    var vc, pub, pubD;
    var initUtils = function(_vc, _pub, _pubD) {
        vc   = _vc;
        pub  = _pub;
        pubD = _pubD;
    };
    SAPO.Project.Video.initUtils = initUtils;
    var pendingJsonpRequests = 0;
    var isJsonpIdle = true;
    var processJsonpRequest = function(uri, delta) {
        var wasIdle = isJsonpIdle;
        pendingJsonpRequests += delta;
        var isIdle = pendingJsonpRequests === 0;
        var changed = wasIdle !== isIdle;
        /*console.log('%s %s %s (%s) %s',
            uri,
            delta === 1 ? '+1' : '-1',
            pendingJsonpRequests,
            isIdle ? 'IDLE' : 'WAITING',
            changed ? 'CHANGED!' : ''
        );*/
        isJsonpIdle = isIdle;
        if (changed) {
            pub('loading_data_changed', !isIdle);
        }
    };

    var jsonpCORS = function(uri, onOk, onErr, timeout/*, tryToSendCookies, isSynchronous*/) {
        processJsonpRequest(uri, 1);
        new JsonP(
            uri,
            {
                onFailure: function() {
                    //console.log('jsonp failure');
                    processJsonpRequest(uri, -1);
                    onErr();
                },
                onAbort: function() {
                    //console.log('jsonp abort');
                    processJsonpRequest(uri, -1);
                    onErr();
                },
                onComplete: function(data) {
                    //console.log('jsonp complete', data);
                    processJsonpRequest(uri, -1);
                    onOk(data);
                },
                timeout: timeout
            }
        );
    };


    /**
     * @function cors
     * @param {String}   uri
     * @param {Function} okCb
     * @param {Function} errCb
     * @param {optional Number} timeout in seconds
     * @param {optional Boolean} try to send cookies
     */
    var cors = function(/*uri, onOk, onErr, timeout, tryToSendCookies, isSynchronous*/) {
        var useFlash = (
            SAPO.Project.Video.Features.hasFlash &&
            !SAPO.Project.Video.Features.hasCORS
            //(!SAPO.Project.Video.Features.hasCORS && !!tryToSendCookies)
        );

        //console.log('CORS ' + (useFlash ? 'FSH' : 'XHR') + ' TO: ' + uri.substring(0, 40));

        var impl = useFlash ? flashCORS : ajaxCORS;

        // cache breaker
        //args[0] = uri + '&rnd=' + ~~(Math.random()*100000);

        impl.apply(null, arguments);
    };


    SAPO.Utility.ajaxCORS  = ajaxCORS;
    SAPO.Utility.flashCORS = flashCORS;
    SAPO.Utility.jsonpCORS = jsonpCORS;
    SAPO.Utility.cors      = cors;



    // LOCALSTORAGE ABSTRACTION

    var fakeLS = {};

    var save = function(key, val) {
        try { // safari's porn mode throws exception if setItem is called
            if (!('localStorage' in window)) { throw 'argh'; }
            localStorage.setItem('sv_' + key, JSON.stringify(val) );
        } catch (ex) {
            fakeLS[key] = val;
        }
    };

    var load = function(key, defaultVal) {
        if ('localStorage' in window) {
            try { // if no prior data or problem parsing JSON falls back to default
                var val = localStorage.getItem('sv_' + key);
                if (val === null) { throw 'default'; }
                return JSON.parse(val);
            } catch (ex) {
                return defaultVal;
            }
        }
        return (fakeLS[key] !== undefined) ? fakeLS[key] : defaultVal;
    };

    SAPO.Utility.load = load;
    SAPO.Utility.save = save;


    SAPO.Utility.maximizeBox = function(maxSz, realSz, forceMaximize) {
        var w = realSz[0];
        var h = realSz[1];
        var boxSz;

        if (forceMaximize || (w > maxSz[0] || h > maxSz[1]) ) {
            var arImg = w / h;
            var arMax = maxSz[0] / maxSz[1];
            var s = (arImg > arMax) ? maxSz[0] / w : maxSz[1] / h;
            boxSz = [parseInt(w * s, 10), parseInt(h * s, 10)];
        }
        else {
            boxSz = realSz.slice();
        }

        var padSz = [
                parseInt( (maxSz[0] - boxSz[0]) / 2 , 10 ),
                parseInt( (maxSz[1] - boxSz[1]) / 2 , 10 )
        ];

        return [boxSz, padSz];
    };



    // MD5

    var rotateLeft = function(lval, ibits) {
        return (lval << ibits) | (lval >>> (32 - ibits));
    };

    var addUnsigned = function(lX, lY) {
        var lX4, lY4, lX8, lY8, lResult;
        lX8 = (lX & 0x80000000);
        lY8 = (lY & 0x80000000);
        lX4 = (lX & 0x40000000);
        lY4 = (lY & 0x40000000);
        lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
        if (lX4 & lY4) {                return (lResult ^ 0x80000000 ^ lX8 ^ lY8); }
        if (lX4 | lY4) {
            if (lResult & 0x40000000) { return (lResult ^ 0xC0000000 ^ lX8 ^ lY8); }
            else {                      return (lResult ^ 0x40000000 ^ lX8 ^ lY8); }
        } else {
            return (lResult ^ lX8 ^ lY8);
        }
    };

    var _F = function(x, y, z) { return (x & y) | ((~x) & z); };
    var _G = function(x, y, z) { return (x & z) | (y & (~z)); };
    var _H = function(x, y, z) { return (x ^ y ^ z);          };
    var _I = function(x, y, z) { return (y ^ (x | (~z)));     };

    var _FF = function(a, b, c, d, x, s, ac) {
        a = addUnsigned(a, addUnsigned(addUnsigned(_F(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
    };

    var _GG = function(a, b, c, d, x, s, ac) {
        a = addUnsigned(a, addUnsigned(addUnsigned(_G(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
    };

    var _HH = function(a, b, c, d, x, s, ac) {
        a = addUnsigned(a, addUnsigned(addUnsigned(_H(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
    };

    var _II = function(a, b, c, d, x, s, ac) {
        a = addUnsigned(a, addUnsigned(addUnsigned(_I(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
    };

    var convertToWordArray = function(str) {
        var lWordCount;
        var lMessageLength = str.length;
        var lNumberOfWords_temp1 = lMessageLength + 8;
        var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
        var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
        var lWordArray = new Array(lNumberOfWords - 1);
        var lBytePosition = 0;
        var lByteCount = 0;
        while (lByteCount < lMessageLength) {
            lWordCount = (lByteCount - (lByteCount % 4)) / 4;
            lBytePosition = (lByteCount % 4) * 8;
            lWordArray[lWordCount] = (lWordArray[lWordCount] | (str.charCodeAt(lByteCount) << lBytePosition));
            lByteCount++;
        }
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
        return lWordArray;
    };

    var wordToHex = function(lValue) {
        var wordToHexValue = "",
            wordToHexValue_temp = "",
            lByte, lCount;
        for (lCount = 0; lCount <= 3; lCount++) {
            lByte = (lValue >>> (lCount * 8)) & 255;
            wordToHexValue_temp = "0" + lByte.toString(16);
            wordToHexValue = wordToHexValue + wordToHexValue_temp.substr(wordToHexValue_temp.length - 2, 2);
        }
        return wordToHexValue;
    };

    var k, AA, BB, CC, DD, a, b, c, d,
        x = [],
        S11 = 7,
        S12 = 12,
        S13 = 17,
        S14 = 22,
        S21 = 5,
        S22 = 9,
        S23 = 14,
        S24 = 20,
        S31 = 4,
        S32 = 11,
        S33 = 16,
        S34 = 23,
        S41 = 6,
        S42 = 10,
        S43 = 15,
        S44 = 21;

    var md5 = function(str) {
        /*jshint maxstatements:100*/

        // Calculates the md5 hash of a string
        // version: 1107.2516
        // discuss at: http://phpjs.org/functions/md5
        var xl;

        x = convertToWordArray(str);
        a = 0x67452301;
        b = 0xEFCDAB89;
        c = 0x98BADCFE;
        d = 0x10325476;

        xl = x.length;
        for (k = 0; k < xl; k += 16) {
            AA = a;
            BB = b;
            CC = c;
            DD = d;
            a = _FF(a, b, c, d, x[k +  0], S11, 0xD76AA478);
            d = _FF(d, a, b, c, x[k +  1], S12, 0xE8C7B756);
            c = _FF(c, d, a, b, x[k +  2], S13, 0x242070DB);
            b = _FF(b, c, d, a, x[k +  3], S14, 0xC1BDCEEE);
            a = _FF(a, b, c, d, x[k +  4], S11, 0xF57C0FAF);
            d = _FF(d, a, b, c, x[k +  5], S12, 0x4787C62A);
            c = _FF(c, d, a, b, x[k +  6], S13, 0xA8304613);
            b = _FF(b, c, d, a, x[k +  7], S14, 0xFD469501);
            a = _FF(a, b, c, d, x[k +  8], S11, 0x698098D8);
            d = _FF(d, a, b, c, x[k +  9], S12, 0x8B44F7AF);
            c = _FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
            b = _FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
            a = _FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
            d = _FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
            c = _FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
            b = _FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
            a = _GG(a, b, c, d, x[k +  1], S21, 0xF61E2562);
            d = _GG(d, a, b, c, x[k +  6], S22, 0xC040B340);
            c = _GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
            b = _GG(b, c, d, a, x[k +  0], S24, 0xE9B6C7AA);
            a = _GG(a, b, c, d, x[k +  5], S21, 0xD62F105D);
            d = _GG(d, a, b, c, x[k + 10], S22, 0x2441453);
            c = _GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
            b = _GG(b, c, d, a, x[k +  4], S24, 0xE7D3FBC8);
            a = _GG(a, b, c, d, x[k +  9], S21, 0x21E1CDE6);
            d = _GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
            c = _GG(c, d, a, b, x[k +  3], S23, 0xF4D50D87);
            b = _GG(b, c, d, a, x[k +  8], S24, 0x455A14ED);
            a = _GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
            d = _GG(d, a, b, c, x[k +  2], S22, 0xFCEFA3F8);
            c = _GG(c, d, a, b, x[k +  7], S23, 0x676F02D9);
            b = _GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
            a = _HH(a, b, c, d, x[k +  5], S31, 0xFFFA3942);
            d = _HH(d, a, b, c, x[k +  8], S32, 0x8771F681);
            c = _HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
            b = _HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
            a = _HH(a, b, c, d, x[k +  1], S31, 0xA4BEEA44);
            d = _HH(d, a, b, c, x[k +  4], S32, 0x4BDECFA9);
            c = _HH(c, d, a, b, x[k +  7], S33, 0xF6BB4B60);
            b = _HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
            a = _HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
            d = _HH(d, a, b, c, x[k +  0], S32, 0xEAA127FA);
            c = _HH(c, d, a, b, x[k +  3], S33, 0xD4EF3085);
            b = _HH(b, c, d, a, x[k +  6], S34, 0x4881D05);
            a = _HH(a, b, c, d, x[k +  9], S31, 0xD9D4D039);
            d = _HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
            c = _HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
            b = _HH(b, c, d, a, x[k +  2], S34, 0xC4AC5665);
            a = _II(a, b, c, d, x[k +  0], S41, 0xF4292244);
            d = _II(d, a, b, c, x[k +  7], S42, 0x432AFF97);
            c = _II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
            b = _II(b, c, d, a, x[k +  5], S44, 0xFC93A039);
            a = _II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
            d = _II(d, a, b, c, x[k +  3], S42, 0x8F0CCC92);
            c = _II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
            b = _II(b, c, d, a, x[k +  1], S44, 0x85845DD1);
            a = _II(a, b, c, d, x[k +  8], S41, 0x6FA87E4F);
            d = _II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
            c = _II(c, d, a, b, x[k +  6], S43, 0xA3014314);
            b = _II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
            a = _II(a, b, c, d, x[k +  4], S41, 0xF7537E82);
            d = _II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
            c = _II(c, d, a, b, x[k +  2], S43, 0x2AD7D2BB);
            b = _II(b, c, d, a, x[k +  9], S44, 0xEB86D391);
            a = addUnsigned(a, AA);
            b = addUnsigned(b, BB);
            c = addUnsigned(c, CC);
            d = addUnsigned(d, DD);
        }

        return [wordToHex(a), wordToHex(b), wordToHex(c), wordToHex(d)].join('').toLowerCase();
    };

    SAPO.Utility.md5 = md5;

    var genId = function(prefix, len) {
        return (prefix || '') + ( ~~(Math.random() * Math.pow(32, len || 6)) ).toString(32);
    };

    SAPO.Utility.genId = genId;

    var objectKeys = function(o) {
        var keys = [];
        if (typeof o === 'object') {
            for (var k in o) {
                if (!o.hasOwnProperty(k)) { continue; }
                keys.push(k);
            }
        }
        return keys;
    };

    SAPO.Utility.objectKeys = objectKeys;

})(window);
